import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=0be2f968&scoped=true"
import script from "./dynamic.vue?vue&type=script&lang=js"
export * from "./dynamic.vue?vue&type=script&lang=js"
import style0 from "./dynamic.vue?vue&type=style&index=0&id=0be2f968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be2f968",
  null
  
)

export default component.exports